<template>
    <section class="styleprofilebandwidth">
        <div class="stylemodal" v-if="boxValue === 'style1'">
            <div class="title_block">
                <h3 class="mb-0 font-active">Style :
                    <span class="">{{ item?.sub_type_1 || item?.sub_type || item?.setting }}</span>
                </h3>
            </div>
            <div class="mt-3">
                <!-- CYO RING SETTING STYLES -->
                <div class="ring_box"
                    v-if="(moduleSubType === 'ring' || complete === 'ring' || presetsubtype === 'preset' || moduleSubType === 'in-stock-pendant') && (props.detailData?.sub_type !== 'in-stock-ring') && moduleSubType !== 'earring'">
                    <!-- Box for CYO RING Style display from setting to complete for ring setting only -->
                    <!-- Generice Content for Ring style -->
                    <p class="mb-0">
                        Style refers to the overall look and design of a ring. There are several ring styles
                        to choose from, all offering a unique appearance.
                    </p>
                    <br>
                    <div class="image_block my-3 text-center">
                        <img :src="'/settingactive/' + lowercase(item?.sub_type) + '.svg'" width="115" height="72">
                        <p class="title mb-0">{{ item?.sub_type }}</p>
                    </div>
                    <!-- Dynamic Content  -->
                    <p class="mb-0" v-if="item?.sub_type === 'halo'">A halo setting features smaller diamonds
                        encircling the center stone, forming a halo effect that enhances its brilliance
                        while making it appear larger.</p>
                    <p class="mb-0" v-if="item?.sub_type === 'solitaire'">A solitaire setting highlights the
                        beauty of a single diamond, usually mounted on a simple band, showcasing its
                        brilliance and elegance without distractions.</p>
                    <p class="mb-0" v-if="item?.sub_type === 'three-stone'">A three stone setting features
                        three diamonds, often representing the past, present, and future, creating a
                        balanced and meaningful design with added sparkle.</p>
                    <p class="mb-0" v-if="item?.sub_type === 'side-stone'">A side stone setting enhances the
                        central stone with smaller stones on either side, adding extra brilliance and
                        complementing the main gem's shine.</p>
                    <p class="mb-0" v-if="item?.sub_type === 'vintage'">A vintage setting is inspired by
                        vintage charm, this setting features intricate detailing and classic design elements
                        that offer a regal, classic look to celebrate bygone eras.</p>


                </div>
                <!-- Box for CYO Earring Style -->
                <div class="earr_box" v-if="moduleSubType === 'earring' || item?.sub_type  === 'in-stock-earring'">
                    <!-- Generice Content for CYO Earring Stylee -->
                    <p>
                        Earrings come in a variety of shapes, sizes, and styles. Each style offers a unique
                        way to enhance a look, ranging from classy solitaire studs, to bold danglers.
                        Whether you prefer a subtle sparkle or a standout design, there’s an earring style
                        to suit all tastes.
                    </p>
                    <div class="image_block my-3 text-center" v-if="item.sub_type === 'in-stock-earring'">
                        <img width="150" height="72":src="'/settingactive/' + lowercase(item?.sub_type_1) + '.svg'">

                        <p class="title mb-0">{{ item?.sub_type_1 }}</p>
                    </div>
                    <div class="image_block my-3 text-center" v-else>
                        <img :width="moduleSubType === 'earring' || moduleSubType === 'pendant' || moduleSubType === 'in-stock-pendant' ? '150' : '72'"
                            :height="moduleSubType === 'earring' || moduleSubType === 'pendant' || moduleSubType === 'in-stock-pendant' ? '150' : '72'"
                            :src="'/settingactive/webshop/' +
                                (moduleSubType === 'earring'
                                    ? 'e' + lowercase(item?.sub_type)
                                    : moduleSubType === 'pendant'
                                        ? 'p' + lowercase(item?.sub_type)
                                        : lowercase(item?.sub_type)) + '.svg'" alt="Style" />

                        <p class="title mb-0">{{ item?.sub_type }}</p>
                    </div>

                    <p class="mb-0" v-if="item?.sub_type === 'dangle' || item?.sub_type_1 === 'dangle'">Dangle earrings hang below the
                        earlobes, typically swinging or moving as you move. They come in a variety of
                        lengths and styles and can be delicate or bold.</p>
                    <p class="mb-0" v-if="item?.sub_type === 'stud' || item?.sub_type_1 === 'stud'">Stud earrings are small earrings that
                        sit directly on the earlobe. Typically featuring a simple gemstone, they are secured
                        with a post that passes through the ear and is held in place by a backing. </p>
                    <p class="mb-0" v-if="item?.sub_type === 'hoop' || item?.sub_type_1 === 'hoop'">Hoop earrings are circular or
                        semi-circular earrings that loop around the earlobe. Available in various sizes,
                        shapes and designs, they range from simple hoops to more elaborate designs. </p>
                </div>
                <!-- box for pendant style -->
                <div class="pendant_box" v-if="moduleSubType === 'pendant' || item?.sub_type === 'in-stock-pendant'">
                    <!-- Generice Content for for pendant style -->
                    <p>A pendant is a piece of {{ $t('jewelry') }} that hangs from a chain, worn around the
                        neck. Pendants come in a wide variety of styles, ranging from simple designs to
                        intricate pieces. Whether you are looking for a subtle piece or something more loud,
                        we have a pendant that will suit any occasion.</p>

                    <div class="image_block my-3 text-center">
                        <div class="in-stockpendant" v-if="item?.sub_type === 'in-stock-pendant'">
                            <img width="150" height="72"
                                :src="'/settingactive/' + lowercase(item?.sub_type_1) + '.svg'">
                        </div>
                        <div v-else>
                            <img :width="moduleSubType === 'earring' || moduleSubType === 'pendant' ? '150' : '72'"
                                :height="moduleSubType === 'earring' || moduleSubType === 'pendant' ? '150' : '72'"
                                :src="'/settingactive/webshop/' +
                                    (moduleSubType === 'earring'
                                        ? 'e' + lowercase(item?.sub_type)
                                        : moduleSubType === 'pendant'
                                            ? 'p' + lowercase(item?.sub_type)
                                            : lowercase(item?.sub_type)) + '.svg'" alt="Style" />
                        </div>

                        <p class="title mb-0" v-if="item?.sub_type === 'in-stock-pendant'">{{ item?.sub_type_1 }}</p>
                        <p class="title mb-0" v-else>{{ item?.sub_type }}</p>
                    </div>

                    <p class="mb-0" v-if="item?.sub_type === 'halo'">Halo pendants feature a central diamond
                        that is surrounded by a circle of smaller stones, creating a halo effect. This
                        design makes the centerstone look larger and is an incredibly popular choice.</p>
                    <p class="mb-0" v-if="item?.sub_type === 'solitaire' || item.sub_type_1 === 'solitaire'">A solitaire
                        pendant features a
                        single, prominently displayed diamond set in a simple design. This is a classy and
                        timeless choice. It can vary in size, and diamond shape. </p>
                    <p class="mb-0" v-if="item?.sub_type === 'lariat'">Lariat necklaces are designed with a
                        long, open-ended chain that loops through or drapes around the neck. This style
                        offers versatility and is adjustable.</p>
                </div>
                <!-- box for matching band style -->
                <div class="matching"
                    v-if="props.item?.sub_type === 'band-ring' || props.item?.sub_type === 'anniversary-ring'">
                    <!--Generice Content for matching band style -->
                    <p>Band styles can range from something as simple as a plain band to something bolder
                        with accent diamonds. There are a variety of styles to choose from</p>

                    <div class="image_block my-3 text-center" v-if="item?.sub_type_1">
                        <img width="130" height="72" :src="'/settingactive/' + lowercase(item?.sub_type_1) + '.svg'"
                            alt="matching band">
                        <p class="title mb-0">{{ item?.sub_type_1 }}</p>
                    </div>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'seven-stone'">A band adorned with seven
                        dazzling stones, each marking a special moment in your journey together.</p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'plain'">A classic, unadorned
                        band that offers timeless simplicity and understated elegance.</p>
                    <p class="mb-0" v-if="item.sub_type_1 === 'half-eternity'">A band adorned
                        with diamonds halfway around, combining elegance with a touch of sparkle.</p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'full-eternity'">A timeless
                        design featuring diamonds encircling the entire band, symbolizing endless love and
                        brilliance.</p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'unique'">A distinctive band with
                        a one-of-a-kind design, crafted to stand out and make a statement.</p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'curve'">A gracefully curved band
                        that fits seamlessly with other rings, adding a touch of unique sophistication.</p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'five-stone'">Five sparkling stones adorn this
                        band, marking the key moments and cherished milestones of your relationship.</p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'two-stones'">Features two diamonds of
                        different shapes that beautifully symbolize the union of two souls, with each
                        diamond representing a unique connection. Set in a sleek band, this ring is the
                        perfect representation of everlasting love and commitment. </p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'solitaire'">Highlights the beauty of a single
                        gemstone, usually mounted on a simple band, showcasing its brilliance and elegance
                        without distractions.</p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'eternity-ring'">A band featuring diamonds all
                        around the band. The perfect ring for any ensemble. </p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'couple-bands'">Couple bands are matching his
                        and her bands that are a symbol of two people’s shared love and commitment. </p>

                </div>
                <!-- seperate solo content-->
                <div class="solo_box" v-if="props.detailData?.sub_type !== 'band-ring' && props.item?.sub_type === 'in-stock-ring'">

                    <!-- Generice Content for two stone -->

                    <div class="image_block my-3 text-center" v-if="item?.sub_type_1">
                        <img :src="'/settingactive/' + lowercase(item?.sub_type_1) + '.svg'">
                        <p class="title mb-0">{{ item?.sub_type_1 }}</p>
                    </div>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'two-stones'">Features two diamonds of
                        different shapes that beautifully symbolize the union of two souls, with each
                        diamond representing a unique connection. Set in a sleek band, this ring is the
                        perfect representation of everlasting love and commitment.
                    </p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'solitaire'">Highlights the beauty of a single
                        gemstone, usually mounted on a simple band, showcasing its brilliance and elegance
                        without distractions.
                    </p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'eternity-ring'">A band featuring diamonds all
                        around the band. The perfect ring for any ensemble.
                    </p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'couple-bands'">Couple bands are matching his
                        and her bands that are a symbol of two people’s shared love and commitment.
                    </p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'five-stone'">Five sparkling stones adorn this
                        band, marking the key moments and cherished milestones of your relationship.
                    </p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'halo'">Smaller diamonds encircle the center
                        stone, forming a halo effect that enhances its brilliance while making it appear
                        larger.
                    </p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'three-stone'">Features three gemstones, often
                        representing the past, present, and future, creating a balanced and meaningful
                        design with added sparkle.
                    </p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'side-stone'">Enhances the central stone with
                        smaller stones on either side, adding extra brilliance and complementing the main
                        gem's shine.
                    </p>
                    <p class="mb-0" v-if="item?.sub_type_1 === 'vintage'">Inspired by vintage charm, this
                        ring features intricate detailing and classic design elements that offer a regal,
                        classic look to celebrate bygone eras.
                    </p>
                </div>

                <!-- <p class="mb-0" v-if="item === 'classic'">lorem ipsum</p> -->
            </div>
        </div>

        <div class="bandwidth" v-if="boxValue === 'band1'">
            <div class="title_block">
                <h3 class="mb-0 font-active">
                    {{ bandTitle }} :
                    <span>{{ bandWidth?.includes('mm') ? bandWidth : bandWidth + ' mm' }}</span>
                </h3>
            </div>
            <div class="mt-3">
                <div class="iamge_block text-center my-3">
                    <img src="/settingactive/bandwidth.svg" width="115" height="72" alt="bandwidth">
                    <p class="title"> {{ bandWidth?.includes('mm') ? bandWidth : bandWidth + ' mm' }}</p>
                </div>
                <p class="mb-0">The band width refers to the width of the ring’s band. The width typically ranges from
                    1.7mm to 7mm. Narrow bands appear delicate, while wider bands look bold.
                </p>

                <!-- Preset and CYO route and type -->
                <p class="mb-0 text mt-1" v-if="showPresetOrCYOMsg">*The bandwidth varies according to ring size and the
                    center stone weight.</p>

                <!-- Specific for 5,& 7 Stone -->

                <p class="mb-0 text mt-1" v-if="showFiveOrSevenStoneMsg">*The bandwidth varies according to ring size.
                </p>

                <!-- below for wedding band only -->

                <p class="mb-0 text mt-1" v-if="showAnniversaryRingMsg">*The bandwidth varies according to ring size and
                    the total carat weight.</p>
            </div>

        </div>

        <div class="profile" v-if="boxValue === 'profile'">
            <div class="title_block">
                <h3 class="mb-0 font-active">Profile: <span>{{ item?.profile }}</span> </h3>

            </div>
            <div class="mt-3">
                <p>A ring’s profile can be low or high. This refers to how the center stone sits on the band.</p>

                <div class="image_block_profile my-2 text-center">
                    <div @click="setActive('low')" :class="{ active: activeSpreadProfile === 'low' }">
                        <img width="150" height="72" v-show="activeSpreadProfile !== 'low'"
                            src="~/assets/presetdetails/low.svg" alt="Low" />
                        <img width="150" height="72" v-show="activeSpreadProfile === 'low'" src="/settingactive/low.svg"
                            alt="Low" />
                        <p
                            :class="{ 'inactive': activeSpreadProfile !== 'low', 'active-text': activeSpreadProfile === 'low' }">
                            Low</p>
                    </div>


                    <div @click="setActive('high')" :class="{ active: activeSpreadProfile === 'High' }">
                        <img width="150" height="72" v-show="activeSpreadProfile !== 'high'"
                            src="/loose_setting/high.svg" alt="High" />
                        <img width="150" height="72" v-show="activeSpreadProfile === 'high'"
                            src="/settingactive/high.svg" alt="High" />
                        <p
                            :class="{ 'inactive': activeSpreadProfile !== 'high', 'active-text': activeSpreadProfile === 'high' }">
                            High</p>
                    </div>
                </div>
                <p class="mb-0" v-if="activeSpreadProfile === 'high'">In a high-profile setting, the diamond sits
                    elevated on the finger, offering greater visibility for the diamond. It pairs beautifully with
                    multiple matching bands for a stunning stacked look.</p>
                <p class="mb-0" v-if="activeSpreadProfile === 'low'">In a low profile setting, the center stone securely
                    sits closer to the finger, offering a sleeker, more subtle look. It pairs beautifully with curved,
                    chevron bands or other low profile bands.</p>

            </div>
        </div>

        <div class="diamondspread" v-if="boxValue === 'diamond'">
            <div class="title_block">
                <h3 class="mb-0 font-active">Diamond Spread : <span>{{ item?.diamond_spread }}%</span></h3>
            </div>
            <div class="mt-3">
                <!-- <p class="mb-0" v-if="item === ''">Diamond spread on a ring setting refers to the arrangement and distribution of smaller diamonds across the band or around a center stone. This enhances the overall sparkle and appearance of the ring.</p> -->
                <p>Diamond spread refers to the percentage of the shank that is covered with diamonds. Diamond spread is
                    usually 50%, 75%, or 100%. The spread can enhance the overall sparkle and appearance of the ring.
                </p>

                <div class="image_block_profile my-2 text-center">
                    <div @click="setDiamond('50')" :class="{ 'active': activeSpreadDiamond === '50' }">
                        <img width="150" height="72" v-show="activeSpreadDiamond !== '50'"
                            src="~/assets/presetdetails/fifty.svg" alt="diamond spread" />
                        <img width="150" height="72" v-show="activeSpreadDiamond === '50'"
                            src="/settingactive/fifty.svg" alt="diamond spread" />
                        <p
                            :class="{ 'inactive': activeSpreadDiamond !== '50', 'active': activeSpreadDiamond === '50' }">
                            50%</p>
                    </div>

                    <div @click="setDiamond('75')" :class="{ 'active': activeSpreadDiamond === '75' }">
                        <img width="150" height="72" v-show="activeSpreadDiamond !== '75'"
                            src="~/assets/presetdetails/seventyfive.svg" alt="diamond spread" />
                        <img width="150" height="72" v-show="activeSpreadDiamond === '75'"
                            src="/settingactive/seventyfive.svg" alt="diamond spread" />
                        <p
                            :class="{ 'inactive': activeSpreadDiamond !== '75', 'active': activeSpreadDiamond === '75' }">
                            75%</p>
                    </div>

                    <div @click="setDiamond('100')" :class="{ 'active': activeSpreadDiamond === '100' }">
                        <img width="150" height="72" v-show="activeSpreadDiamond !== '100'"
                            src="~/assets/presetdetails/hundred.svg" alt="diamond spread" />
                        <img width="150" height="72" v-show="activeSpreadDiamond === '100'"
                            src="/settingactive/hundred.svg" alt="diamond spread" />
                        <p
                            :class="{ 'inactive': activeSpreadDiamond !== '100', 'active': activeSpreadDiamond === '100' }">
                            100%</p>
                    </div>
                </div>

                <p class="mb-0" v-if="activeSpreadDiamond === '50'">Half of the shank features diamonds, providing a
                    balance between diamond presence and metal visibility.</p>
                <p class="mb-0" v-if="activeSpreadDiamond === '75'">With diamonds covering three-quarters of the shank,
                    this design delivers an impressive sparkle while preserving a touch of metal for contrast.</p>
                <p class="mb-0" v-if="activeSpreadDiamond === '100'">The entire shank is covered with diamonds, offering
                    maximum sparkle and brilliance.</p>
            </div>
        </div>
    </section>
</template>

<script setup>
// Style 
const flagShowModal = ref(false);
const props = defineProps(['item', 'styleBandParams', 'title', 'moduleSubType', 'detailData', 'type', 'styleBandBox', 'addtionalAttirbute', 'boxValue', 'presetsubtype', 'complete'])
const route = useRoute()
// console.log(props, 'STYLEBAND',route?.params?.type);

const lowercase = (value) => {
    return value?.toLowerCase().replace(/[^\w\s]/gi, '');
}

// Bandwidth
const bandWidthtypes = ['couple-bands-ring', 'band-ring', 'in-stock-ring', 'anniversary-ring'];
const bandTitle = computed(() => {
    if (props?.presetsubtype == 'preset' || props?.moduleSubType === 'ring' || props?.complete === 'ring') {
        return 'Band Width'
    }
    else if (bandWidthtypes) {
        return 'Average Width'
        // return props?.detailData?.setting?.min_width && detailData?.setting.max_width
    }

})
const bandWidth = computed(() => {
    if (props?.item?.sub_type === "in-stock-ring") {
        return `${props?.item?.setting?.min_width} / ${props?.item?.setting?.max_width}`
    }
    else if (props?.presetsubtype === 'preset' || props?.moduleSubType === 'ring' || props?.complete === 'ring') {
        return props?.item?.width;
    }
    else {
        return props?.addtionalAttirbute?.average_width;
    }

})
const activeSpreadProfile = ref(props?.item?.profile)
watch(() => props.item?.profile, (newValue) => {
    activeSpreadProfile.value = newValue;
});
// Diamond spread
const activeSpreadDiamond = ref(props?.item?.diamond_spread)
watch(() => props.item?.diamond_spread, (newValue) => {
    activeSpreadDiamond.value = newValue;
});
const setActive = (spread) => {
    nextTick(() => {
        activeSpreadProfile.value = spread;
    });
};
const setDiamond = (spread) => {
    nextTick(() => {
        activeSpreadDiamond.value = spread;
    });
};
const showPresetOrCYOMsg = computed(() => {
    return (
        props.detailData?.sub_type !== 'in-stock-ring' &&
        (route?.meta?.moduleType === 'cyo' || props.type === 'preset') &&
        !['five-stone', 'seven-stone', 'anniversary-ring'].includes(props.detailData?.sub_type_1)
    );
});

const showFiveOrSevenStoneMsg = computed(() => {
    return (
        props.detailData?.sub_type !== 'in-stock-ring' &&
        props.type !== 'preset' &&
        !['anniversary-ring'].includes(props.detailData?.sub_type) &&
        ['five-stone', 'seven-stone'].includes(props.detailData?.sub_type_1)
    );
});


const showAnniversaryRingMsg = computed(() => {
    return props.detailData?.sub_type === 'anniversary-ring' || 'couple-bands-ring' &&
        props.type !== 'preset' && props.detailData?.sub_type !== 'in-stock-ring' && route?.meta?.moduleType !== 'cyo';
});
// sub_type : "in-stock-ring" 
</script>



<style scoped>
.largesvg {
    transform: scale(1.3);
}

.img_box {
    height: 130px;
}

.pop_open {
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
}

p {
    font-size: 16px;
    color: #606060;
}

.title_block span {
    cursor: pointer;
    color: var(--green);
}

h3 {
    font-size: 22px;
}

.m-info {
    margin: 10px 0;
}

.image_block {
    text-align: center;
}

.text {
    color: #909090;
    font-size: 14px;
    font-style: italic;
}

.image_block_profile {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.image_block p {
    font-size: 16px;
    color: #668b84;
    font-weight: 600;
}

.image_block_profile p {
    text-decoration: underline;
    font-weight: 600;
    color: #668b84;
}

.image_block,
.image_block_profile .inactive {
    color: #909090;
}

.image_block,
.image_block_profile .active-text {
    color: var(--green);
}

.title {
    text-transform: capitalize;
    color: #668b84;
    font-size: 16px;

}

@media(max-width: 767px) {
    h3 {
        font-size: 20px;
    }

    p {
        font-size: 14px;
    }

    .acc_box {
        min-width: 60px;
        font-size: 14px;
        padding: 3px 8px;
    }
}
</style>
